import { useFlag } from '@unleash/proxy-client-react';

import { EFeatureFlags } from '@/types';

export const useFeatureFlag = (featureFlag: keyof typeof EFeatureFlags): boolean => {
  const flag = useFlag(EFeatureFlags[featureFlag]);

  return flag;
};
